import React from "react";

const PdfViewer = () => {
  return (
    <div style={{ height: "100vh" }}>
      <iframe
        src="/agreement.pdf" // ✅ domain-root based path
        title="Agreement"
        width="100%"
        height="100%"
        style={{ border: "none" }}
      />
    </div>
  );
};

export default PdfViewer;